import React from 'react'
import { Flex, FlexProps } from '@chakra-ui/react'

import PageSelect from './page-select'
import PageSizeSelect from './page-size-select'
import { PageControlsType } from '~utils/hooks/use-page-controls'
import { PageSizeType, SetStateFn } from '~config/constants'

type PageControls = Omit<PageControlsType, 'setPageSize'> & {
    setPageSize?: SetStateFn<PageSizeType>
}

interface Props extends PageControls {
    layoutOverrides?: FlexProps
    count: number
    /** More results exist past `count` (the server stopped counting). */
    isCountCapped?: boolean
}

export default function Pagination({
    page,
    setPage,
    pageSize,
    setPageSize,
    count,
    isCountCapped = false,
    layoutOverrides,
}: Props) {
    return (
        <Flex justifyContent="flex-end" gap={6} {...layoutOverrides}>
            <PageSelect
                page={page}
                setPage={setPage}
                count={count}
                isCountCapped={isCountCapped}
                pageSize={pageSize}
            />
            {setPageSize && (
                <PageSizeSelect
                    size={pageSize}
                    setSize={setPageSize}
                    total={count}
                    isTotalCapped={isCountCapped}
                />
            )}
        </Flex>
    )
}
